/* eslint-disable */
// @ts-nocheck
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** Store and promotional offers linked to a charging point. */
export type ChargingPool = {
  __typename?: 'ChargingPool';
  /** The charging pool hosting the charging point */
  chargingPoolId: Scalars['ID']['output'];
  /** Promotional offers available for this location */
  promotionalOffers: Array<PromotionalOffer>;
  /**
   * The store hosting the charging pool.
   * Null when no store is associated with this charging location.
   */
  store?: Maybe<Store>;
};

export type ChargingPoolInput = {
  /** Identifier of the charging point (OCPI EVSE ID) */
  evseId: Scalars['String']['input'];
};

/**
 * One of the (up to) 3 charging offers (ECO / FAST / ULTRA) available on a charging pool,
 * derived from connector power on its charging points.
 */
export type ChargingPoolOffer = {
  __typename?: 'ChargingPoolOffer';
  /** Maximum electric power among connectors backing this offer */
  maxElectricPower: ElectricPower;
  /**
   * Price per kWh including VAT for this offer.
   * Null when the CPO tariff cannot be resolved.
   */
  priceInclVat?: Maybe<Money>;
  /** Slots available for this offer */
  slots: Array<Slot>;
  /** The offer tier this entry represents */
  type: OfferType;
};

/** The charging offers available on a charging pool. */
export type ChargingPoolOffers = {
  __typename?: 'ChargingPoolOffers';
  /** Up to 3 offers (ECO / FAST / ULTRA), one per distinct power tier on this charging pool */
  offers: Array<ChargingPoolOffer>;
};

export type ChargingPoolOffersInput = {
  /** The charging pool to retrieve offers for */
  chargingPoolId: Scalars['ID']['input'];
};

/** ISO 4217 currency codes supported by this API. */
export enum Currency {
  /** Euro. */
  Eur = 'EUR',
  Unknown = 'UNKNOWN'
}

/** Instantaneous or maximum electric power. */
export type ElectricPower = {
  __typename?: 'ElectricPower';
  /** Unit of the power value. */
  unit: PowerUnit;
  /** Power value expressed in the given unit. */
  value: Scalars['Float']['output'];
};

/** A monetary amount. amountInCents is always in the smallest currency unit (e.g., 1050 = €10.50). */
export type Money = {
  __typename?: 'Money';
  /**
   * Amount in the smallest currency unit (cents for EUR).
   * Named amountInCents — not amount — to prevent accidental assignment of euro values.
   */
  amountInCents: Scalars['Int']['output'];
  /** ISO 4217 currency code. */
  currency: Currency;
};

/** Supported charging offer tiers, based on connector power. */
export enum OfferType {
  Eco = 'ECO',
  Fast = 'FAST',
  Ultra = 'ULTRA',
  Unknown = 'UNKNOWN'
}

export enum PowerUnit {
  Kw = 'KW',
  Unknown = 'UNKNOWN',
  W = 'W'
}

/** A publicly visible, currently active promotional offer. */
export type PromotionalOffer = {
  __typename?: 'PromotionalOffer';
  /** The type of promotional offer */
  type: PromotionalOfferType;
};

/** Identifies a promotional offer. */
export enum PromotionalOfferType {
  /** Free first charge campaign, valid in 2026. */
  FirstFreeCharge_2026 = 'FIRST_FREE_CHARGE_2026',
  /** Free first charge campaign, second edition. */
  FirstFreeChargeV2 = 'FIRST_FREE_CHARGE_V2',
  Unknown = 'UNKNOWN'
}

export type Query = {
  __typename?: 'Query';
  chargingPool?: Maybe<ChargingPool>;
  chargingPoolOffers?: Maybe<ChargingPoolOffers>;
};


export type QueryChargingPoolArgs = {
  input: ChargingPoolInput;
};


export type QueryChargingPoolOffersArgs = {
  input: ChargingPoolOffersInput;
};

/** A retail chain operating one or more stores (e.g. Decathlon, Auchan, Leroy Merlin). */
export type Retailer = {
  __typename?: 'Retailer';
  /** Display name of the retailer */
  name: Scalars['String']['output'];
};

/** A slot is a time period during which a charging offer is available. */
export type Slot = {
  __typename?: 'Slot';
  /** CPO payment URL for this slot */
  cpoPaymentUrl: Scalars['String']['output'];
  /** The name of the slot (e.g. "01", "02", "03") */
  name: Scalars['String']['output'];
};

/** The retail store hosting the charging pool linked to a charging point. */
export type Store = {
  __typename?: 'Store';
  /** Human-readable store name, e.g. "Auchan Valenciennes". */
  name: Scalars['String']['output'];
  /** The retailer operating this store */
  retailer: Retailer;
};

export type GetChargingPoolQueryVariables = Exact<{
  input: ChargingPoolInput;
}>;


export type GetChargingPoolQuery = { __typename?: 'Query', chargingPool?: { __typename?: 'ChargingPool', chargingPoolId: string, store?: { __typename?: 'Store', name: string, retailer: { __typename?: 'Retailer', name: string } } | null, promotionalOffers: Array<{ __typename?: 'PromotionalOffer', type: PromotionalOfferType }> } | null };

export type GetChargingPoolOffersQueryVariables = Exact<{
  input: ChargingPoolOffersInput;
}>;


export type GetChargingPoolOffersQuery = { __typename?: 'Query', chargingPoolOffers?: { __typename?: 'ChargingPoolOffers', offers: Array<{ __typename?: 'ChargingPoolOffer', type: OfferType, maxElectricPower: { __typename?: 'ElectricPower', value: number, unit: PowerUnit }, priceInclVat?: { __typename?: 'Money', amountInCents: number, currency: Currency } | null, slots: Array<{ __typename?: 'Slot', name: string, cpoPaymentUrl: string }> }> } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const GetChargingPoolDocument = new TypedDocumentString(`
    query GetChargingPool($input: ChargingPoolInput!) {
  chargingPool(input: $input) {
    chargingPoolId
    store {
      name
      retailer {
        name
      }
    }
    promotionalOffers {
      type
    }
  }
}
    `) as unknown as TypedDocumentString<GetChargingPoolQuery, GetChargingPoolQueryVariables>;
export const GetChargingPoolOffersDocument = new TypedDocumentString(`
    query GetChargingPoolOffers($input: ChargingPoolOffersInput!) {
  chargingPoolOffers(input: $input) {
    offers {
      type
      maxElectricPower {
        value
        unit
      }
      priceInclVat {
        amountInCents
        currency
      }
      slots {
        name
        cpoPaymentUrl
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetChargingPoolOffersQuery, GetChargingPoolOffersQueryVariables>;